import { kebabCase } from 'lodash'

type DataTagTypes =
  | 'button'
  | 'block'
  | 'tag'
  | 'input'
  | 'navigation'
  | 'tab'
  | 'checkbox'

type GetDataTagsOptions = {
  name: string
  type: DataTagTypes
}

export const getDataTags = ({
  name,
  type,
}: GetDataTagsOptions): Record<string, string> => {
  const dataTarget = kebabCase(`${name}-${type}`)
  return {
    [`data-bp-target`]: dataTarget,
  }
}
